import {createApp} from 'vue'
import Store from 'store'
import options from './SiteNavigation.options'
import MegaMenu from './SiteNavigationMegaMenu.vue'
import SearchMenu from './SiteNavigationSearchMenu.vue'
import parseMenuAsJson from './methods/scrapers'

const el = '.nlx-component--site-navigation'
const DOM = document.querySelector(el)
const component = createApp(options).use(Store)

const megaMenuEl = '.nlx-component--mega-menu'
const megaMenuDOM = document.querySelector(megaMenuEl)
const megaMenuComponent = createApp(MegaMenu).use(Store)

const searchMenuEl = '.nlx-component--search-menu'
const searchMenuDOM = document.querySelector(searchMenuEl)
const searchMenuComponent = createApp(SearchMenu).use(Store)

if (searchMenuDOM) {
    Store.commit('main/set_search_page_url',searchMenuDOM.dataset.searchpageurl)
}

if(DOM && megaMenuDOM && searchMenuDOM){

    const megaMenuData = parseMenuAsJson(DOM)

    Store.commit('main/set_mega_menu_data',megaMenuData)

    const template = DOM.innerHTML
    options.template = template
    
    component.mount(el)
    megaMenuDOM.classList.add('nlx-site-navigation__mega-menu')
    megaMenuComponent.mount(megaMenuEl)
    searchMenuDOM.classList.add('nlx-site-navigation__mega-menu','nlx-site-navigation__mega-menu__search-menu')
    searchMenuComponent.mount(searchMenuEl)

} else {
    console.error('SiteNavigation not loading: Missing part of the menu.','Has DOM:',!!DOM,'Has megaMenuDOM',!!megaMenuDOM,'Has searchMenuDOM',!!searchMenuDOM)
}

